import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCamera } from "@fortawesome/free-solid-svg-icons/faCamera";
import isString from "lodash/isString";
import React from "react";

import { ThemeType } from "../theme/Theme";
import { getMediaUrl } from "../utils/Media";
import { AtiraIcon } from "./AtiraIcon";
import { AtiraImage, AtiraImageProps } from "./Image";

interface ImageCreateEditProps extends Omit<AtiraImageProps, "src"> {
  icon?: IconProp;
  iconColor?: keyof ThemeType;
  src?: string | File;
}

export const ImageCreateEdit: React.FC<ImageCreateEditProps> = ({
  src,
  icon = faCamera,
  iconColor = "main",
  ...props
}) => {
  if (!src) {
    return <AtiraIcon icon={icon} color={iconColor} />;
  }

  if (isString(src)) {
    const isGoogleImageURL = src.startsWith(
      "https://lh3.googleusercontent.com/",
    );
    const isBlobURL = src.startsWith("blob:");

    return (
      <AtiraImage
        src={isGoogleImageURL || isBlobURL ? src : getMediaUrl(src)}
        {...props}
      />
    );
  }

  if (src instanceof File) {
    return <AtiraImage src={URL.createObjectURL(src)} {...props} />;
  }

  return <AtiraIcon icon={icon} color={iconColor} />;
};
